import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { ListaCentrosCardComponent } from "./lista-centros-card/lista-centros-card.component";

@NgModule({
	declarations: [ListaCentrosCardComponent],
	imports: [CommonModule, MatIconModule, TranslateModule],
	exports: [ListaCentrosCardComponent],
})
export class SharedListaCentrosModule {}
